import {
  StopListSettings,
  useStopLists,
  useStopListSettings,
} from "@/api/stop-list.api";
import { SettingsContainer } from "@/components/layout/SettingsContainer";
import { StopList } from "@/types/campaign";
import { ToOptions, useNavigate } from "@tanstack/react-router";
import { CampaignStopWindowDropdown } from "./CampaignStopWindowDropdown";

type Props = {
  currentStopLists: StopList[];
  onSubmit: (data: string[]) => void;
  backLinkOptions?: ToOptions;
  padding?: boolean;
  border?: boolean;
  settings?: StopListSettings;
  isCreating?: boolean;
  stopLists?: StopList[];
};

export function CampaignStopWindow({
  currentStopLists,
  onSubmit,
  backLinkOptions,
  padding,
  border,
  isCreating = false,
}: Props) {
  const { data: globalStopLists } = useStopLists();

  const availableStopLists: StopList[] = [...(globalStopLists || [])];

  const handleDropdownSubmit = (stopListIds: string[]) => {
    onSubmit(stopListIds);
  };

  return (
    <SettingsContainer
      backLinkOptions={backLinkOptions}
      padding={padding}
      border={border}
    >
      <CampaignStopWindowDropdown
        isCreating={isCreating}
        currentStopLists={currentStopLists}
        onSubmit={handleDropdownSubmit}
        availableStopLists={availableStopLists}
      />
    </SettingsContainer>
  );
}
